import * as React from "react";
import * as Reach from "@reach/router";
import styled from "@emotion/styled";
import MediaQueryContext, { initMediaQueryStore } from "@/contexts/MediaQuery";
import RoutingContext, { initRoutingStore } from "@/contexts/Routing";
import PageTransition from "@/components/PageTransition";
import MediaQuery from "@/components/MediaQuery";
import Routing from "@/components/Routing";
import contract from "@/utils/contract";
import ContractContext, { initContractStore } from "@/contexts/Contract";
import OverlayContext, { initOverlayStore } from "@/contexts/Overlay";
import Loading from "@/components/organisms/Loading";
import SnackBarContext, { initSnackBarStore, snackBarInitialState } from "@/contexts/SnackBar";
import ErrorBoundary from "@/components/ErrorBoundary";
import SnackBarCard from "@/components/organisms/SnackBarCard";

const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = Reach.useLocation();
  const mediaQueryStore = initMediaQueryStore("sm");
  const routingStore = initRoutingStore(location.pathname);
  const contractStore = initContractStore(contract);
  const overlayStore = initOverlayStore(false);
  const snackBarStore = initSnackBarStore(snackBarInitialState);

  return (
    <MediaQueryContext.Provider value={mediaQueryStore}>
      <MediaQuery />
      <RoutingContext.Provider value={routingStore}>
        <Routing path={location.pathname} />
        <PageTransition location={location}>
          <ContractContext.Provider value={contractStore}>
            <SnackBarContext.Provider value={snackBarStore}>
              <OverlayContext.Provider value={overlayStore}>
                <ErrorBoundary>
                  <Page>{children}</Page>
                </ErrorBoundary>
                <SnackBarCard />
                <Loading />
              </OverlayContext.Provider>
            </SnackBarContext.Provider>
          </ContractContext.Provider>
        </PageTransition>
      </RoutingContext.Provider>
    </MediaQueryContext.Provider>
  );
};

export default Layout;
